export interface PseCreationAnchorResponse {
  createdBenefitId?: string | null
  creationCapability?: {
    createdBenefitId?: string | null
  } | null
}

/**
 * Returns the server-owned PSE anchor, including after a reload or a lost create response.
 * The anchor is read-only UI state: it never causes a save or another creation request.
 */
export function durablePseBenefitId(response: PseCreationAnchorResponse | null | undefined): string | null {
  return response?.createdBenefitId ?? response?.creationCapability?.createdBenefitId ?? null
}

/** Route used by both a fresh creation handoff and a durable resume action. */
export function pseBenefitResumePath(benefitId: string): string {
  return `/benefit-applications/new?applicationId=${encodeURIComponent(benefitId)}&step=household`
}
